<template>
  <b-modal
    id="modal-edit-member-approve"
    centered
    :title="`審批${approveData.supplier && approveData.supplier.company_name_cn}會員合約`"
    size="lg"
    @ok.prevent="handleEdit"
    ok-title="提交"
    cancel-title="取消"
    :ok-disabled="false"
  >
    <div>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form class="pt-1" @submit.prevent="handleSubmit(onSubmit)">
            <b-row>
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="簽署日期"
                  rules="required"
                >
                  <b-form-group
                    label="簽署日期："
                    label-for="signed_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="approveData.signed_date"
                      class="form-control"
                      :config="config"
                      placeholder="選擇簽署日期"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="審批狀態"
                  rules="required"
                >
                  <b-form-group
                    label="審批狀態："
                    label-for="member_contract_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <div class="form-col-select">
                      <v-select
                        id="member_contract_status_id"
                        v-model="approveData.member_contract_status_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="memberContractStatuses"
                        label="name"
                        :reduce="(option) => option.id"
                        :clearable="false"
                        placeholder="選擇審批狀態"
                      />
                      <feather-icon size="18" icon="ChevronDownIcon" />
                    </div>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              

              <b-col cols="12">
                <b-form-group
                  label="備註："
                  label-for="approve_note"
                  label-cols-md="3"
                >
                  <b-form-textarea
                    id="approve_note"
                    v-model="approveData.approve_note"
                    placeholder="輸入備註"
                    rows="3"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="拒絕原因："
                  label-for="reject_reason"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-textarea
                    id="reject_reason"
                    v-model="approveData.reject_reason"
                    placeholder="輸入拒絕原因"
                    rows="3"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BFormCheckbox,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BFormTextarea,
} from "bootstrap-vue";
import axiosIns from "@/libs/axios";
import { ref, onMounted } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      config: {
        dateFormat: "Y-m-d",
        maxDate: "today",
      },
    };
  },
  props: {
    approveData: {
      type: Object,
      required: true,
    },
    memberContractStatuses: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isRejected() {
      return this.approveData.member_contract_status_id === 3;
    },
  },
  methods: {
    hideModal() {
      this.$root.$emit(
        "bv::hide::modal",
        "modal-edit-member-approve",
        "#btnShow"
      );
    },
    handleEdit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axiosIns
            .post("/member/contract", this.approveData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                confirmButtonText: "確定",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.$emit("refetch-data");
              this.hideModal();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const resetApproveData = () => {
      props.approveData = JSON.parse(JSON.stringify({ id: 0 }));
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetApproveData);

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      loading,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.form-col-select {
  position: relative;

  .feather-icon {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
</style>